import React from "react";

import AttributeTabs from "./components/picklistData/picklist-tabs";

//Parent Component to include Picklist Data in Admin -> Clients -> Picklist Data
const PicklistData = () => {
    return (
        <div id="picklist-data-admin">
            <h1>Picklist Data</h1>
            <AttributeTabs />
        </div>
    );
};

export default PicklistData;
